import { GET_PARCHI_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { ParchiGenericApiResponse } from "../types/parchi";

export default async function getDeveloperSdkAuthInit(
  authToken?: string
): Promise<
  ParchiGenericApiResponse<{
    access_token: string;
    expires_in: number;
    refresh_token: string;
    refresh_expires_in: number;
  }>
> {
  try {
    const PARCHI_HOST = GET_PARCHI_HOST();
    let endpoint = `${PARCHI_HOST}/sdk/init`;

    const res = await fetch(endpoint, {
      method: "GET",
      redirect: "follow",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(authToken && { auth: authToken }),
      },
    });

    return res.json();
  } catch (e) {
    return { success: false };
  }
}
